import { createComponent } from "@opendash/state";
import { Spin } from "antd";
import * as React from "react";
import styled from "styled-components";
import { $parse } from "../..";
export const AuthLayout = createComponent(function AuthLayout({ children, width = 600, }) {
    const currentTenant = $parse.auth.currentTenant;
    return (React.createElement(Container, null,
        React.createElement(Content, { width: width },
            (currentTenant === null || currentTenant === void 0 ? void 0 : currentTenant.logo) && (React.createElement("img", { src: currentTenant === null || currentTenant === void 0 ? void 0 : currentTenant.logo, alt: currentTenant === null || currentTenant === void 0 ? void 0 : currentTenant.label })),
            $parse.auth.loading ? React.createElement(Spin, null) : React.createElement(Box, { width: width }, children)),
        React.createElement(Background, null)));
});
export const Container = styled.div `
  position: absolute;

  display: flex;
  justify-content: center;
  align-items: center;

  overflow: hidden;

  height: 100%;
  width: 100%;
  padding: 10px;
`;
export const Content = styled.div `
  width: 100%;
  max-width: ${(p) => p.width}px;
  // padding: 24px 24px;

  z-index: 2;

  img {
    width: auto;
    max-width: 60%;
    display: block;
    margin: 0 auto;
    margin-bottom: 24px;
  }
`;
export const Box = styled.div `
  padding: 24px 24px;
  background: white;
  border-bottom: 3px solid var(--ant-primary-color);
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
`;
export const Title = styled.div `
  text-align: center;
  font-size: 20px;
  margin-bottom: 10px;
  text-transform: uppercase;
  letter-spacing: 5px;
`;
export const SwitchState = styled.div `
  text-align: center;
  font-size: 12px;
  margin-top: 20px;
`;
export const Background = styled.div `
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;

  height: 100vh;
  width: 100vw;

  /* background: black; */

  z-index: 1;

  ::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;

    height: 100vh;
    width: 100vw;

    opacity: 0.5;
    filter: blur(5px);
    transform: scale(1.1);

    background-attachment: fixed;
    background-position: center;
    background-size: cover;
  }
`;
//# sourceMappingURL=data:application/json;base64,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